/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import Helper from "../utils/Helper";

// summary
export const getSummaryType = summary =>
  summary && summary.type ? summary.type : null;
export const getSummaryName = summary =>
  summary && summary.name ? summary.name : null;
export const getSummaryValue = summary =>
  summary && summary.value ? summary.value : null;
export const getSummaryText = summary =>
  summary && summary.text ? summary.text : null;

// wallet
export const getWalletBalance = wallet =>
  wallet && wallet.balance
    ? Helper.formatPriceNumber(wallet.balance)
    : Helper.formatPriceNumber(0);
export const getWalletUsable = wallet =>
  wallet && wallet.usable
    ? Helper.formatPriceNumber(wallet.usable)
    : Helper.formatPriceNumber(0);
export const getWalletMax = wallet =>
  wallet && wallet.max
    ? Helper.formatPriceNumber(wallet.max)
    : Helper.formatPriceNumber(0);
export const getWalletUsed = wallet =>
  wallet && wallet.used
    ? Helper.formatPriceNumber(wallet.used)
    : Helper.formatPriceNumber(0);
export const getWalletValue = wallet =>
  wallet && wallet.value
    ? Helper.formatPriceNumber(wallet.value)
    : Helper.formatPriceNumber(0);
export const getWalletAttributeIsUseMax = wallet =>
  wallet && wallet.attribute && wallet.attribute.is_use_max
    ? wallet.attribute.is_use_max
    : false;
export const getWalletAttributeIsApplied = wallet =>
  wallet && wallet.attribute && wallet.attribute.is_applied
    ? wallet.attribute.is_applied
    : false;
export const getWalletAttributeIsUsable = wallet =>
  wallet && wallet.attribute && wallet.attribute.is_usable
    ? wallet.attribute.is_usable
    : false;

// point
export const getPointBalance = point =>
  point && point.balance ? point.balance : 0;
export const getPointUsable = point =>
  point && point.usable ? point.usable : 0;
export const getPointMax = point => (point && point.max ? point.max : 0);
export const getPointUsed = point => (point && point.used ? point.used : 0);
export const getPointValue = point =>
  point && point.value ? Helper.point.value : 0;
export const getPointAttributeIsUseMax = point =>
  point && point.attribute && point.attribute.is_use_max
    ? point.attribute.is_use_max
    : false;
export const getPointAttributeIsApplied = point =>
  point && point.attribute && point.attribute.is_applied
    ? point.attribute.is_applied
    : false;
export const getPointAttributeIsUsable = point =>
  point && point.attribute && point.attribute.is_usable
    ? point.attribute.is_usable
    : false;

// payment
export const getPaymentTotal = payment =>
  payment && payment.total
    ? Helper.formatPriceNumber(payment.total)
    : Helper.formatPriceNumber(0);
export const getPaymentBalance = payment =>
  payment && payment.balance
    ? Helper.formatPriceNumber(payment.balance)
    : Helper.formatPriceNumber(0);
export const getPaymentItems = payment =>
  payment && payment.items ? payment.items : null;



// WEBPACK FOOTER //
// ./src/selectors/checkout.js